interface ILiferay {
	ThemeDisplay: {
		getBCP47LanguageId: () => string
		getCanonicalURL: () => string
		getCompanyGroupId: () => string
		getCompanyId: () => string
		getDefaultLanguageId: () => string
		getLanguageId: () => string
		getLayoutRelativeURL: () => string
		getLayoutURL: () => string
		getPathContext: () => string
		getPathThemeImages: () => string
		getPortalURL: () => string
		getScopeGroupId: () => number
		getURLHome: () => string
		getUserEmailAddress: () => string
		getUserId: () => string
		getUserName: () => string
		isSignedIn: () => boolean
	}
	Language:{
		get: (key: string) => string
	}
	authToken: string
	detach: (eventName: string, payload?: any) => any
	fire: (eventName: string, data: any) => boolean
	on: (eventName: string, payload?: any) => any

}

declare global {
	interface Window {
		Liferay: ILiferay
	}
}

export const Liferay = window.Liferay || {
	/* parámetros para testear en ambiente local */
	ThemeDisplay: {
		getCanonicalURL: () => window.location.href,
		getCompanyGroupId: () => '',
		getCompanyId: () => '',
		getDefaultLanguageId: () => 'es_ES',
		getLanguageId: () => 'es_ES',
		getLayoutRelativeURL: () => '',
		getLayoutURL: () => '',
		getPathContext: () => '',
		getPathThemeImages: () => '',
		getPortalURL: () => '',
		getScopeGroupId: () => '',
		getURLHome: () => '',
		getUserId: () => '',
		getUserName: () => '',
		isSignedIn: () => {
			return false;
		},
	},
	Language: {
		get: (key) => key,
	},
	authToken: null,
	detach: (type: any, callback: any) => window.removeEventListener(type, callback),
	fire: (name: string, data: any) => window.dispatchEvent(
			new CustomEvent(name, {
				bubbles: true,
				composed: true,
				detail: data
			})			
		),
	on: (name, callback) => window.addEventListener(name, callback)
}
